import { StackedColumnChart } from '@/components/Charts';

const createStackLegendFormatter = function () {
  const allSeries = this.chart.series as Highcharts.Series[];

  const stackTotals: Record<string, number> = allSeries.reduce(
    (totals, series) => {
      const { stack, custom } = series.options as any;
      const stackName = stack || series.name;
      const total = custom?.total ?? 0;
      totals[stackName] = (totals[stackName] ?? 0) + total;
      return totals;
    },
    {} as Record<string, number>
  );

  const { stack } = this.options as any;
  const stackName = stack || this.name;
  const total = stackTotals[stack] ?? 0;

  const isStackAlreadyRendered = allSeries.slice(0, this.index).some((s) => {
    const prevStack = (s.options as any).stack || s.name;
    return prevStack === stackName;
  });

  if (isStackAlreadyRendered) return null;

  return `
    <span style="font-size: 14px; font-weight: 600;">${stack}</span><br>
    <strong style="font-size: 16px; font-weight: 800;">${total}</strong>
  `;
};
const stackedTooltipFormatter = function (this: any) {
  const { points, key } = this;
  const stack = this.hoveredStackName || '-';
  const labelMap: Record<string, string> = {
    total_completes: 'Completed',
    total_terminated: 'Terminated',
  };
  const defaultData = [
    { series: { name: 'total_completes', color: '#6e3fa3' }, y: 0 },
    { series: { name: 'total_terminated', color: '#d0bfe7' }, y: 0 },
  ];

  const filteredPoints = points?.filter(
    (point) => point.series.options.stack === stack
  );
  const pointsToDisplay =
    filteredPoints.length > 0 ? filteredPoints : defaultData;
  return `
    <div style="font-family: 'Jakarta', sans-serif; padding: 12px;">
      <span style="color: #140606; font-size: 16px; font-weight: 800;">${stack}</span><br />
      <span style="color: #50405E; font-size: 12px; font-weight: 600;">${key}</span>
      <div style="height: 1px; width: 100%; background-color: #F0EEED; margin: 8px 0 10px;"></div>
      ${pointsToDisplay
        ?.map((point) => {
          const displayLabel = labelMap[point.series.name] || point.series.name;
          return `
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px;">
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background-color: ${point.color};"></span>
                <span style="color: #50405E; font-size: 12px; font-weight: 600;">
                  ${displayLabel}
                </span>
              </div>
              <div>
                <strong style="color: #3B0764; font-weight: 800; font-size: 14px; margin-left: 20px;">
                  ${point.y}
                </strong>
              </div>
            </div>
          `;
        })
        .join('')}
    </div>
  `;
};

interface Series {
  name?: string;
  data: { y: number; color?: string }[];
}

interface StackedColumnWithGroupsChartProps {
  series: Series[];
  categories: string[];
  title: string;
  subtitle?: string;
  headerTooltip?: string;
  headerStats?: { label: string; value: number }[];
}

export const StackedColumnWithGroupsChart = ({
  series,
  categories,
  ...rest
}: StackedColumnWithGroupsChartProps) => {
  return (
    <StackedColumnChart
      {...rest}
      series={series}
      categories={categories}
      labelFormatter={createStackLegendFormatter}
      tooltipFormatter={stackedTooltipFormatter}
      customColors={[
        '#6e3fa3',
        '#d0bfe7',
        '#f35e5d',
        '#faa7a7',
        '#ee9847',
        '#f7c697',
        '#c7ae8e',
        '#e0d2bf',
        '#489295',
        '#c0e0e1',
      ]}
    />
  );
};
